import { Typography } from "@mui/material";

const shopDetails = {
    banner: {
        title: "Mperito Shop",
        subTitle: "Provide seamless shopping experience to your customers with your own branded app",
        button1Label: "Get Started",
        button2Label: "Request Demo",
        backgroundImage: "/assets/solutions/shop/mperito_shop_banner.jpg"
    },
    sectionHeading: {
        title: <span>
            Your Own Digital Shop!{' '}
            <Typography component="span" variant="inherit" color="primary">
                Solution Is Here
            </Typography>
        </span>,
        subTitle: "Essential Pages & features to ensure your online store is completely digital with streamlined backend operations"
    },
    features: [
        {
            label: 'BRANDING',
            title: 'Essential Pages',
            description:
                'All the important pages to display your products and content',
            illustration: '/assets/images/solution/shop/essential_pages_sm.jpg',
            list: [
                "Homepage",
                "Product Listing",
                "Product Details Page",
                "Contact Page",
                "About Page",
                "All Policy Pages"
            ]
        },
        {
            label: 'OPERATIONS',
            title: 'Manage Transactions',
            description:
                'All vital pages that enables customer to transact and place orders',
            illustration: '/assets/images/solution/enablement.jpg',
            list: [
                "Single Cart view across channels",
                "Order Capture",
                "Order Fulfilment ( Shipping & Delivery )",
                "Favourites",
                "Quotations Workflow ( can be converted to order )",
                "Addresses"
            ]
        },
        {
            label: 'ANALYSE',
            title: 'Insights',
            description:
                'As the transactions take place the vital statistics available for decision making',
            illustration: '/assets/images/solution/shop/insights_sm.jpg',
            list: [
                "Order Insights",
                "Revenue Insights",
                "Trends on product Sales",
                "Valued Customers"
            ],
        },
        {
            label: 'SETUP',
            title: 'Configure Digital Store',
            description:
                'Setup your store with simplified screens',
            illustration: '/assets/images/solution/shop/setup_sm.jpg',
            list: [
                "Categories & Products",
                "Payment Gateway",
                "Pricing & Inventory",
                "Contact Details",
                "Branding Theme",
                "News & Communications"
            ],
        },
        {
            label: 'CONTROL',
            title: "POS to manage offline store",
            description:
                'Get in control of the complete business at your finger tips',
            illustration: '/assets/images/solution/shop/mperito_pos_sm.jpg',
            list: [
                "Leverage your mobile or tablet as POS",
                "Order on behalf of customer",
                "Generate and Print Bills / Invoices",
                "View and Process Orders",
                "Manage Categories, Products, Pricing & Inventory"
            ],
        },
        {
            label: 'VALUE',
            title: "What\'s More",
            description:
                'The value genenrated by going online with MPERITO',
            illustration: '/assets/images/solution/shop/mperito_values_sm.jpg',
            list: [
                "Mobile Validated Genuine customers",
                "Sharing of Products to friends and family",
                "Reviews and Rating against the products purchased",
                "Order copy for delivery",
                "GST Tax Invoice generated automatically"
            ],
        }
    ]
}

export default shopDetails;